import templateUrl from "./choose-worksheets-modal.html"

export const ChooseWorksheetsModalComponent = {
    controllerAs: "vm",
    templateUrl,
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: class ChooseWorksheetsModalController {
        $onInit() {
            this.worksheets = this.resolve.worksheets;
            this.worksheetOptions = this.worksheets.map(function (sheet, i) {
                return {
                    id: i,
                    name: sheet.sheetName,
                    selected: sheet.selected
                };
            });
            this.selectedWorksheets = this.worksheetOptions.filter(function (sheet) {
                return sheet.selected;
            });
        }

        onDismiss() {
            this.dismiss({ $value: 'cancel' });
        }

        onClose() {
            // Accept button click.
            const res = this.worksheets.map((worksheet, i) => {
                const selected = this.selectedWorksheets.filter(function (selectedWorksheet) {
                    return selectedWorksheet.id === i;
                }).length > 0;

                return {
                    sheetName: worksheet.sheetName,
                    selected: selected
                };
            })
            this.close({ $value: res });
        }
    }
}
